(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-article"]) return;
  try {
    
document.querySelectorAll('.nka').forEach(article=>{const list=article.querySelector('[data-article-toc]');const toc=article.querySelector('.nka-toc');const layout=article.querySelector('.nka-layout');if(!list||!toc||!layout)return;layout.prepend(toc);if(window.matchMedia('(max-width:760px)').matches)toc.open=false;article.querySelectorAll('.nka-body h2').forEach((heading,i)=>{if(!heading.id)heading.id='guia-'+(i+1);const title=heading.textContent;const item=document.createElement('li');const link=document.createElement('a');link.href='#'+heading.id;link.textContent=title;item.append(link);list.append(item);const match=title.match(/^(\d+)\s*·\s*(.*)$/);if(match){const num=document.createElement('span');num.className='nka-step';num.textContent=match[1];const label=document.createElement('span');label.textContent=match[2];heading.replaceChildren(num,label);}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-header"] && !Shopify.designMode) return;
  try {
    
  class NekupiCartCount extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      import('@shopify/events').then(({ StandardEvents }) => {
        if (signal.aborted) return;
        document.addEventListener(StandardEvents.cartLinesUpdate, event => {
          event.promise?.then(({cart}) => {
            if (!signal.aborted && typeof cart?.totalQuantity === 'number') this.updateCount(cart.totalQuantity);
          }).catch(() => {});
        }, {signal});
      }).catch(() => {});
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        fetch(this.dataset.cartUrl, {credentials:'same-origin',signal})
          .then(response => response.ok ? response.json() : Promise.reject())
          .then(cart => this.updateCount(cart.item_count)).catch(() => {});
      }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
    updateCount(count) {
      if (!Number.isFinite(count)) return;
      const label = this.dataset.label.replace('__COUNT__', String(count));
      this.querySelector('.nk-cart-count').textContent = String(count);
      this.querySelector('.nk-cart').setAttribute('aria-label', label);
      this.querySelector('[data-cart-status]').textContent = label;
    }
  }
  if (!customElements.get('nekupi-cart-count')) customElements.define('nekupi-cart-count', NekupiCartCount);

  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nk-header details[open]').forEach(detail=>detail.removeAttribute('open'));});
  document.addEventListener('click',event=>{document.querySelectorAll('.nk-header details[open]').forEach(detail=>{if(!detail.contains(event.target))detail.removeAttribute('open');});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-manga-shelf"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nekupi-manga-shelf')) {
  customElements.define('nekupi-manga-shelf', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.stage = this.querySelector('.nk-demo-stage');
      this.slides = Array.from(this.querySelectorAll('.nk-demo-slide'));
      this.counter = this.querySelector('.nk-demo-count');
      this.current = 0;
      this.busy = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.slides.length) return;
      for (let i = this.slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this.slides[i], this.slides[j]] = [this.slides[j], this.slides[i]];
      }
      this.slides.forEach((slide, index) => {
        slide.hidden = index !== 0;
        slide.inert = index !== 0;
        slide.classList.toggle('is-active', index === 0);
        if (index === 0) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.counter.textContent = '01 / ' + this.slides.length;
      const firstImage = this.slides[0].querySelector('img');
      if (firstImage) firstImage.loading = 'eager';
      this.classList.add('nk-shelf-enhanced');
      this.querySelector('.nk-demo-controls').hidden = false;
      this.stage.style.setProperty('--manga-glow', this.slides[0].dataset.accent);
      this.querySelector('.nk-demo-next').addEventListener('click', () => this.show(this.current + 1));
      this.querySelector('.nk-demo-prev').addEventListener('click', () => this.show(this.current - 1));
      this.stage.addEventListener('touchstart', e => { this.startX = e.changedTouches[0].clientX; this.startY = e.changedTouches[0].clientY; }, { passive: true });
      this.stage.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - this.startX;
        const dy = e.changedTouches[0].clientY - this.startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      this.preloadNext();
    }
    preloadNext() {
      const image = this.slides[(this.current + 1) % this.slides.length].querySelector('img');
      if (image && !image.complete) image.loading = 'eager';
    }
    show(index) {
      const next = (index + this.slides.length) % this.slides.length;
      if (this.busy || next === this.current) return;
      this.busy = true;
      const old = this.slides[this.current];
      const active = this.slides[next];
      old.classList.remove('is-active', 'nk-enter');
      old.classList.add('nk-exit');
      old.inert = true;
      old.setAttribute('aria-hidden', 'true');
      active.hidden = false;
      active.inert = false;
      active.removeAttribute('aria-hidden');
      active.classList.add('is-active', 'nk-enter');
      this.stage.style.setProperty('--manga-glow', active.dataset.accent);
      this.current = next;
      this.counter.textContent = String(next + 1).padStart(2, '0') + ' / ' + this.slides.length;
      this.preloadNext();
      clearTimeout(this.transitionTimer);
      this.transitionTimer = setTimeout(() => { old.hidden = true; old.classList.remove('nk-exit'); this.busy = false; }, this.reduced.matches ? 0 : 720);
    }
    disconnectedCallback() { clearTimeout(this.transitionTimer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-manga"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nekupi-manga')) {
  customElements.define('nekupi-manga', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-filter-form]');
      this.grid = this.querySelector('[data-products]');
      this.panel = this.querySelector('[data-filter-panel]');
      this.sort = this.querySelector('[data-sort]');
      this.queryKey = this.dataset.queryKey;
      this.sortKey = this.dataset.sortKey;
      this.feedback = this.querySelector('[data-feedback]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.media = matchMedia('(min-width:1001px)');
      this.panel.open = this.media.matches;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.media.addEventListener('change', () => { this.panel.open = this.media.matches; }, options);
      this.querySelectorAll('[data-enhanced]').forEach(node => { node.hidden = false; });
      this.form.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.filter(), 150); }, options);
      this.form.addEventListener('change', () => this.filter(), options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.filter(); if (!this.media.matches) { this.panel.open = false; this.panel.querySelector('summary').focus(); } }, options);
      this.form.addEventListener('reset', () => { queueMicrotask(() => this.filter()); }, options);
      this.sort.addEventListener('change', () => this.filter(), options);
      this.querySelector('[data-clear]').addEventListener('click', () => this.form.reset(), options);
      window.addEventListener('popstate', () => { this.restore(); this.filter(false); }, options);
      this.loadCatalog();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
    normalize(value) { return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
    seriesForCard(card) {
      let titles = [];
      try { titles = JSON.parse(card.dataset.series || '[]'); } catch {}
      if (!Array.isArray(titles)) titles = [];
      titles = titles.filter(title => typeof title === 'string' && title.trim());
      if (titles.length || this.queryKey !== 'manga_q' || /^Pack\b/i.test(card.dataset.title || '')) return [...new Set(titles)];
      const title = (card.dataset.title || '').trim().replace(/\s+-\s+Edición (?:especial|regular)$/i, '');
      const volume = title.match(/^(.*?)\s+\d{1,3}$/u);
      let series = volume?.[1] || '';
      if (/^All You Need Is Kill\s*·\s*Edición integral$/i.test(title)) series = 'All You Need Is Kill';
      const aliases = {'Ajin (Semihumano)': 'Ajin', 'Soul Eater Perfect Edition': 'Soul Eater'};
      return series ? [aliases[series] || series] : [];
    }
    buildSeriesOptions() {
      this.cardSeries = new Map();
      const counts = new Map();
      this.cards.forEach(card => {
        const titles = this.seriesForCard(card);
        this.cardSeries.set(card, titles);
        titles.forEach(title => counts.set(title, (counts.get(title) || 0) + 1));
      });
      const container = this.querySelector('[data-series-options]');
      const fragment = document.createDocumentFragment();
      [...counts.entries()].sort(([a], [b]) => a.localeCompare(b, document.documentElement.lang, {numeric: true, sensitivity: 'base'})).forEach(([title, count]) => {
        const label = document.createElement('label');
        label.className = 'nkm-check';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.name = 'series';
        input.value = title;
        const name = document.createElement('span');
        name.textContent = title;
        const badge = document.createElement('small');
        badge.dataset.seriesCount = title;
        badge.textContent = count;
        label.append(input, name, badge);
        fragment.append(label);
      });
      container.replaceChildren(fragment);
      container.closest('[data-filter-group]').hidden = counts.size === 0;
    }
    async loadCatalog() {
      const firstPage = new URL(this.dataset.collectionUrl, location.origin);
      firstPage.searchParams.set('page', '1');
      let next = firstPage.href;
      const catalogRevision = String(Date.now());
      const pagination = this.querySelector('[data-pagination]');
      const controls = [...this.form.elements, this.sort];
      controls.forEach(control => { control.disabled = true; });
      if (next) { this.feedback.hidden = false; this.feedback.textContent = this.dataset.loading; }
      try {
        const seen = new Set();
        const freshCards = [];
        const seenPages = new Set();
        while (next) {
          const url = new URL(next, location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          url.searchParams.set('_nk_catalog', catalogRevision);
          if (seenPages.has(url.href)) throw new Error('Repeated page');
          seenPages.add(url.href);
          const response = await fetch(url, {signal: this.controller.signal, cache: 'no-store'});
          if (!response.ok) throw new Error('Catalog unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = documentFragment.querySelector('nekupi-manga');
          if (!section) throw new Error('Missing catalog');
          section.querySelectorAll('[data-card]').forEach(card => {
            if (!seen.has(card.dataset.id)) { seen.add(card.dataset.id); freshCards.push(card); }
          });
          next = section.querySelector('[data-next-page]')?.getAttribute('href');
        }
        this.grid.replaceChildren(...freshCards);
        this.cards = freshCards;
        this.feedback.hidden = true;
        pagination.hidden = true;
        const vendorSelect = this.form.elements.vendor;
        const vendors = [...new Set(this.cards.map(card => card.dataset.vendor).filter(Boolean))].sort();
        vendors.forEach(vendor => vendorSelect.add(new Option(vendor, vendor)));
        this.buildSeriesOptions();
        this.setupSurprise();
        controls.forEach(control => { control.disabled = false; });
        this.restore();
        this.filter(false);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.feedback.hidden = false;
        this.feedback.textContent = this.dataset.error;
        pagination.hidden = false;
      }
    }

    setupSurprise() {
      const panel = this.querySelector('[data-surprise]');
      if (!panel) return;
      const firstVolumes = this.cards.filter(card => /(?:^|[\s-])(?:tomo\s*)?0?1$/i.test(card.dataset.title.trim()) && card.dataset.available === 'true');
      this.surprisePool = firstVolumes;
      if (!this.surprisePool.length) return;
      panel.hidden = false;
      this.querySelector('[data-surprise-button]').addEventListener('click', () => {
        const choices = this.surprisePool.filter(card => card.dataset.id !== this.lastSurprise);
        const pool = choices.length ? choices : this.surprisePool;
        const card = pool[Math.floor(Math.random() * pool.length)];
        this.lastSurprise = card.dataset.id;
        const original = card.querySelector('.nkm-card-link');
        const link = original.cloneNode(true);
        link.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        link.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.sizes = '100px'; });
        const action = card.querySelector('.nkqa')?.cloneNode(true);
        if(action) action.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
        this.querySelector('[data-surprise-card]').replaceChildren(...(action?[link,action]:[link]));
        this.querySelector('[data-surprise-link]').href = original.href;
        this.querySelector('[data-surprise-result]').hidden = false;
        const button = this.querySelector('[data-surprise-button]');
        button.textContent = button.dataset.again;
        button.hidden = this.surprisePool.length < 2;
        this.querySelector('[data-surprise-status]').textContent = card.dataset.title + '. ' + card.querySelector('.nkm-card-bottom').textContent.trim();
      }, {signal: this.controller.signal});
    }
    restore() {
      const params = new URLSearchParams(location.search);
      [this.queryKey,'vendor','min_price','max_price'].forEach(key => { this.form.elements[key].value = params.get(key) || ''; });
      this.form.elements.available.checked = params.get('available') === '1';
      this.form.querySelectorAll('[name="series"]').forEach(input => { input.checked = params.getAll('series').includes(input.value); });
      this.sort.value = params.get(this.sortKey) || 'title';
      if (!this.sort.value) this.sort.value = 'title';
    }
    filter(updateUrl = true) {
      if (this.sort.disabled) return;
      const values = new FormData(this.form);
      const query = this.normalize(values.get(this.queryKey) || '');
      const terms = query.split(/\s+/).filter(Boolean);
      const series = values.getAll('series');
      const vendor = values.get('vendor');
      const min = values.get('min_price') === '' ? 0 : Number(values.get('min_price')) * 100;
      const max = values.get('max_price') === '' ? Infinity : Number(values.get('max_price')) * 100;
      const onlyAvailable = values.has('available');
      let count = 0;
      this.cards.forEach(card => {
        const data = card.dataset;
        const productSeries = this.cardSeries.get(card) || [];
        const text = this.normalize([data.title, ...productSeries, data.vendor, data.tags].join(' '));
        const isIsbn = /^[\d\s-]{6,}$/.test(query);
        const queryMatches = isIsbn ? data.isbn.replace(/\D/g, '').includes(query.replace(/\D/g, '')) : terms.every(term => text.includes(term));
        const matches = queryMatches && (!series.length || productSeries.some(title => series.includes(title))) && (!vendor || data.vendor === vendor) && Number(data.price) >= min && Number(data.price) <= max && (!onlyAvailable || (data.available === 'true' && data.backorder !== 'true'));
        card.hidden = !matches;
        if (matches) count++;
      });
      const compareTitle = (a,b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang, {numeric:true,sensitivity:'base'});
      const sort = this.sort.value;
      this.cards.sort((a,b) => sort === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) || compareTitle(a,b) : sort === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) || compareTitle(a,b) : sort === 'newest' ? Number(b.dataset.created) - Number(a.dataset.created) || compareTitle(a,b) : compareTitle(a,b));
      const fragment = document.createDocumentFragment();
      this.cards.forEach(card => fragment.append(card));
      this.grid.append(fragment);
      this.querySelector('[data-result-count]').textContent = `${count} ${count === 1 ? this.dataset.countOne : this.dataset.countLabel}`;
      this.querySelector('[data-empty]').hidden = count > 0;
      const filtersCount = Number(Boolean(query)) + series.length + Number(Boolean(vendor)) + Number(values.get('min_price') !== '') + Number(values.get('max_price') !== '') + Number(onlyAvailable);
      const badge = this.querySelector('[data-filter-count]');
      badge.hidden = filtersCount === 0;
      badge.textContent = filtersCount;
      this.form.querySelectorAll('[data-filter-group]').forEach(group => {
        const active = [...group.querySelectorAll('input, select')].filter(input => input.type === 'checkbox' ? input.checked : input.value.trim() !== '').length;
        const indicator = group.querySelector('[data-group-count]');
        indicator.hidden = active === 0;
        indicator.textContent = active;
      });
      if (updateUrl) {
        const url = new URL(location.href);
        [this.queryKey,'series','vendor','min_price','max_price','available',this.sortKey,'page'].forEach(key => url.searchParams.delete(key));
        for (const [key,value] of values.entries()) if (String(value).trim()) url.searchParams.append(key, key === 'available' ? '1' : value);
        if (sort !== 'title') url.searchParams.set(this.sortKey, sort);
        history.replaceState(null, '', url);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-quiz"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nekupi-quiz')) {
  customElements.define('nekupi-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.step = 0; this.run = 0;
      this.form = this.querySelector('[data-questions]');
      this.start = this.querySelector('[data-start]');
      this.start.hidden = false;
      this.loggedIn = this.dataset.customer === 'true';
      this.querySelector('[data-continue]').hidden = !this.loggedIn;
      this.querySelector('[data-continue]').addEventListener('click', () => this.continueCollection());
      this.start.addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => {
        this.run++; this.isOpen = false;
        this.querySelector('[data-body]').hidden = true; this.start.hidden = false; this.start.focus();
      });
      this.querySelector('[data-back]').addEventListener('click', () => { this.step--; this.showStep(); });
      this.querySelector('[data-restart]').addEventListener('click', () => this.open());
      this.querySelector('[data-retry]').addEventListener('click', () => this.mode === 'continue' ? this.continueCollection() : this.results());
      this.form.addEventListener('change', () => this.updateButton());
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.form.querySelector(`[data-step="${this.step}"] input:checked`)) return;
        if (this.step < 2) { this.step++; this.showStep(); } else this.results();
      });
    }

    snapshot() {
      if (!this.loggedIn) return Promise.resolve({excludedProductIds: [], recommendations: []});
      if (!this.snapshotPromise) {
        this.snapshotPromise = (async () => {
          try {
            const url = new URL(this.dataset.collectionUrl, location.origin);
            url.searchParams.set('format', 'json'); url.searchParams.set('view', 'quiz');
            const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000)});
            if (!response.ok) throw new Error('Collection unavailable');
            const snapshot = await response.json();
            if (!Array.isArray(snapshot.excludedProductIds) || !Array.isArray(snapshot.recommendations)) throw new Error('Invalid collection response');
            return snapshot;
          } catch {
            this.snapshotPromise = null;
            const error = new Error('Collection unavailable'); error.name = 'CollectionError'; throw error;
          }
        })();
      }
      return this.snapshotPromise;
    }
    personalCard(product) {
      const url = new URL(product.url, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product URL');
      const card = document.createElement('article'); card.className = 'nkq-card';
      const cover = document.createElement('a'); cover.className = 'nkq-cover'; cover.href = url.href;
      const image = document.createElement('img');
      if (product.image) {
        const src = new URL(product.image);
        if (src.protocol === 'https:' && (src.hostname === 'cdn.shopify.com' || src.origin === location.origin)) { image.src = src.href; image.alt = product.title; image.loading = 'lazy'; cover.append(image); }
      }
      const info = document.createElement('div'); info.className = 'nkq-card-info';
      const badge = document.createElement('span'); badge.className = 'nkq-badge'; badge.textContent = product.stock > 0 ? this.labels.stock : this.labels.backorder;
      const heading = document.createElement('h4'), title = document.createElement('a'); title.href = url.href; title.textContent = product.title; heading.append(title);
      const reason = document.createElement('p'); reason.textContent = this.labels.personalNote;
      const price = document.createElement('strong'); price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style: 'currency', currency: 'EUR'}).format(Number(product.price));
      const link = document.createElement('a'); link.href = url.href; link.textContent = this.labels.view;
      info.append(badge, heading, reason, price, link); card.append(cover, info); return card;
    }
    async continueCollection() {
      this.open(); this.mode = 'continue'; const run = ++this.run;
      this.form.hidden = true; this.querySelector('[data-results]').hidden = false;
      this.querySelector('[data-results] h3').textContent = this.labels.personalTitle;
      this.querySelector('[data-note]').textContent = this.labels.loading;
      this.querySelector('[data-progress]').textContent = ''; this.querySelector('[data-cards]').replaceChildren();
      try {
        const snapshot = await this.snapshot();
        if (!this.isOpen || run !== this.run) return;
        const products = snapshot.recommendations.slice(0, 3);
        this.querySelector('[data-cards]').replaceChildren(...products.map(p => this.personalCard(p)));
        this.querySelector('[data-note]').textContent = products.length ? this.labels.personalNote : this.labels.personalEmpty;
      } catch {
        if (!this.isOpen || run !== this.run) return;
        this.querySelector('[data-note]').textContent = this.labels.collectionError; this.querySelector('[data-retry]').hidden = false;
      }
      this.querySelector('[data-results] h3').focus();
    }
    catalog() {
      if (!this.catalogPromise) this.catalogPromise = this.loadCatalog().catch(error => { this.catalogPromise = null; throw error; });
      return this.catalogPromise;
    }
    async loadCatalog() {
      const revision = String(Date.now()), initial = new URL(this.dataset.catalogUrl, location.origin);
      initial.searchParams.set('page', '1');
      let next = initial.href;
      const products = new Map(), pages = new Set();
      while (next) {
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid catalog origin');
        url.searchParams.set('section_id', 'nekupi-quiz-catalog');
        url.searchParams.set('_nk_quiz', revision);
        if (pages.has(url.href)) throw new Error('Repeated catalog page');
        pages.add(url.href);
        const response = await fetch(url, {cache: 'no-store'});
        if (!response.ok) throw new Error('Catalog unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const catalog = page.querySelector('[data-quiz-catalog]');
        if (!catalog) throw new Error('Missing catalog');
        catalog.querySelectorAll('template[data-product]').forEach(product => products.set(product.dataset.productId, product));
        next = catalog.querySelector('[data-next-page]')?.getAttribute('href');
      }
      return [...products.values()];
    }
    open() {
      this.mode = 'discover'; this.snapshotPromise = null;
      this.querySelector('[data-results] h3').textContent = this.labels.results;
      this.run++; this.isOpen = true; this.form.reset(); this.step = 0;
      this.start.hidden = true; this.querySelector('[data-body]').hidden = false;
      this.querySelector('[data-results]').hidden = true; this.querySelector('[data-retry]').hidden = true;
      this.form.hidden = false; this.showStep(); this.catalog().catch(() => {}); this.snapshot().catch(() => {});
    }
    updateButton() { this.querySelector('[data-next]').disabled = !this.form.querySelector(`[data-step="${this.step}"] input:checked`); }
    showStep() {
      this.querySelectorAll('[data-step]').forEach((el, i) => { el.hidden = i !== this.step; });
      this.querySelector('[data-progress]').textContent = this.labels.step.replace('[n]', this.step + 1);
      this.querySelector('[data-bar]').style.width = `${(this.step + 1) / 3 * 100}%`;
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').textContent = this.step === 2 ? this.labels.finish : this.labels.next;
      this.updateButton(); this.form.querySelector(`[data-step="${this.step}"] legend`).focus();
    }
    selectProducts(products, answers, excluded = new Set()) {
      const contains = (str, val) => (str || '').split(' ').includes(val);
      const ranked = products.filter(el =>
        !excluded.has(String(el.dataset.productId).split('/').pop()) && (answers.genre === 'any' || contains(el.dataset.genres, answers.genre)) &&
        (answers.format === 'any' || (answers.format === 'volume' ? el.dataset.format !== 'pack' : el.dataset.format === answers.format))
      ).map(el => ({el, tie: Math.random(), score: answers.tone !== 'any' && contains(el.dataset.tones, answers.tone) ? 4 : 0}))
        .sort((a, b) => b.score - a.score || a.tie - b.tie);
      const seen = new Set();
      return ranked.filter(item => {
        const series = item.el.dataset.series || item.el.dataset.productId;
        if (seen.has(series)) return false;
        seen.add(series); return true;
      }).slice(0, 3);
    }
    async results() {
      const run = ++this.run, answers = Object.fromEntries(new FormData(this.form));
      const cards = this.querySelector('[data-cards]'); cards.replaceChildren();
      this.form.hidden = true; this.querySelector('[data-results]').hidden = false;
      this.querySelector('[data-retry]').hidden = true;
      this.querySelector('[data-note]').textContent = this.labels.loading;
      this.querySelector('[data-progress]').textContent = ''; this.querySelector('[data-results] h3').focus();
      try {
        const [products, snapshot] = await Promise.all([this.catalog(), this.snapshot()]);
        if (!this.isOpen || run !== this.run) return;
        const excluded = new Set((snapshot.excludedProductIds || []).map(id => String(id).split('/').pop()));
        const items = this.selectProducts(products, answers, excluded);
        cards.replaceChildren(...items.map(item => item.el.content.cloneNode(true)));
        this.querySelector('[data-note]').textContent = items.length ? this.labels.note : this.labels.empty;
      } catch (error) {
        if (!this.isOpen || run !== this.run) return;
        this.querySelector('[data-note]').textContent = error.name === 'CollectionError' ? this.labels.collectionError : this.labels.error;
        this.querySelector('[data-retry]').hidden = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-request"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-notify-back]').forEach(link=>{const handle=new URLSearchParams(window.location.search).get('referencia');if(handle && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)){link.href='/products/'+encodeURIComponent(handle);link.textContent=link.dataset.productLabel;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-tcg-machine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nekupi-tcg-machine')){
  customElements.define('nekupi-tcg-machine',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.packs=Array.from(this.querySelectorAll('[data-pack]'));
      this.language=this.querySelector('[data-language]');
      this.budget=this.querySelector('[data-budget]');
      this.draw=this.querySelector('[data-draw]');
      this.status=this.querySelector('[data-status]');
      this.result=this.querySelector('[data-result]');
      this.idle=this.querySelector('[data-idle]');
      this.language.addEventListener('change',()=>this.reset());
      this.budget.addEventListener('change',()=>this.reset());
      this.draw.addEventListener('click',()=>this.reveal());
      this.reset();
    }
    pool(){return this.packs.filter(p=>(this.language.value==='all'||p.dataset.language===this.language.value)&&(!Number(this.budget.value)||Number(p.dataset.price)<=Number(this.budget.value)));}
    reset(){
      clearTimeout(this.timer);this.classList.remove('is-spinning');this.result.hidden=true;this.result.replaceChildren();this.idle.hidden=false;this.language.disabled=false;this.budget.disabled=false;
      const pool=this.pool();this.draw.disabled=!pool.length;this.status.textContent=pool.length?this.dataset.ready.replace('[count]',pool.length):this.dataset.empty;
    }
    reveal(){
      let pool=this.pool();if(!pool.length){this.reset();return;}
      if(pool.length>1)pool=pool.filter(p=>p.dataset.id!==this.previous);
      const pack=pool[Math.floor(Math.random()*pool.length)];
      this.draw.disabled=true;this.language.disabled=true;this.budget.disabled=true;this.result.hidden=true;this.idle.hidden=false;this.classList.add('is-spinning');this.status.textContent=this.dataset.busy;
      this.timer=setTimeout(()=>{
        const card=pack.cloneNode(true);card.removeAttribute('data-pack');
        card.querySelectorAll('[id]').forEach(el=>el.id+='-result');
        this.result.replaceChildren(card);this.idle.hidden=true;this.result.hidden=false;this.classList.remove('is-spinning');this.previous=pack.dataset.id;this.draw.disabled=false;this.language.disabled=false;this.budget.disabled=false;this.status.textContent=card.querySelector('h4').textContent;
      },matchMedia('(prefers-reduced-motion: reduce)').matches?0:650);
    }
    disconnectedCallback(){clearTimeout(this.timer);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekupi-tcg-split"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nekupi-tcg-split')) {
  customElements.define('nekupi-tcg-split', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-filter-form]');
      this.grid = this.querySelector('[data-products]');
      this.panel = this.querySelector('[data-filter-panel]');
      this.sort = this.querySelector('[data-sort]');
      this.game = '';
      this.querySelectorAll('[data-game-choice]').forEach(control => control.addEventListener('click', event => {
        event.preventDefault(); this.game = control.dataset.gameChoice; this.form.reset();
        queueMicrotask(() => { this.filter(); this.querySelector('.nkg-selector').scrollIntoView({behavior:'smooth',block:'nearest'}); });
      }, {signal: (this.gameController ||= new AbortController()).signal}));
      this.queryKey = this.dataset.queryKey;
      this.sortKey = this.dataset.sortKey;
      this.feedback = this.querySelector('[data-feedback]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.media = matchMedia('(min-width:1001px)');
      this.panel.open = this.media.matches;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.media.addEventListener('change', () => { this.panel.open = this.media.matches; }, options);
      this.querySelectorAll('[data-enhanced]').forEach(node => { node.hidden = false; });
      this.form.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.filter(), 150); }, options);
      this.form.addEventListener('change', () => this.filter(), options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.filter(); if (!this.media.matches) { this.panel.open = false; this.panel.querySelector('summary').focus(); } }, options);
      this.form.addEventListener('reset', () => { queueMicrotask(() => this.filter()); }, options);
      this.sort.addEventListener('change', () => this.filter(), options);
      this.querySelector('[data-clear]').addEventListener('click', () => this.form.reset(), options);
      window.addEventListener('popstate', () => { this.restore(); this.filter(false); }, options);
      this.loadCatalog();
    }
    disconnectedCallback() { this.controller?.abort(); this.gameController?.abort(); clearTimeout(this.timer); }
    normalize(value) { return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
    buildSeriesOptions() {
      this.cardSeries = new Map();
      const counts = new Map();
      this.cards.forEach(card => {
        const titles = [...new Set(JSON.parse(card.dataset.series || '[]'))];
        this.cardSeries.set(card, titles);
        titles.forEach(title => counts.set(title, (counts.get(title) || 0) + 1));
      });
      const container = this.querySelector('[data-series-options]');
      const fragment = document.createDocumentFragment();
      [...counts.entries()].sort(([a], [b]) => a.localeCompare(b, document.documentElement.lang, {numeric: true, sensitivity: 'base'})).forEach(([title, count]) => {
        const label = document.createElement('label');
        label.className = 'nkm-check';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.name = 'series';
        input.value = title;
        const name = document.createElement('span');
        name.textContent = title;
        const badge = document.createElement('small');
        badge.dataset.seriesCount = title;
        badge.textContent = count;
        label.append(input, name, badge);
        fragment.append(label);
      });
      container.replaceChildren(fragment);
      container.closest('[data-filter-group]').hidden = counts.size === 0;
    }
    async loadCatalog() {
      let next = this.querySelector('[data-next-page]')?.getAttribute('href');
      if (Number(new URLSearchParams(location.search).get('page')) > 1) {
        const firstPage = new URL(location.href);
        firstPage.searchParams.set('page', '1');
        next = firstPage.href;
      }
      const pagination = this.querySelector('[data-pagination]');
      const controls = [...this.form.elements, this.sort];
      controls.forEach(control => { control.disabled = true; });
      if (next) { this.feedback.hidden = false; this.feedback.textContent = this.dataset.loading; }
      try {
        const seen = new Set(this.cards.map(card => card.dataset.id));
        const seenPages = new Set();
        while (next) {
          const url = new URL(next, location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          if (seenPages.has(url.href)) throw new Error('Repeated page');
          seenPages.add(url.href);
          const response = await fetch(url, {signal: this.controller.signal});
          if (!response.ok) throw new Error('Catalog unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = documentFragment.querySelector('nekupi-tcg-split');
          if (!section) throw new Error('Missing catalog');
          section.querySelectorAll('[data-card]').forEach(card => {
            if (!seen.has(card.dataset.id)) { seen.add(card.dataset.id); this.grid.append(card); this.cards.push(card); }
          });
          next = section.querySelector('[data-next-page]')?.getAttribute('href');
        }
        this.feedback.hidden = true;
        pagination.hidden = true;
        const vendorSelect = this.form.elements.vendor;
        const vendors = [...new Set(this.cards.map(card => card.dataset.vendor).filter(Boolean))].sort();
        vendors.forEach(vendor => vendorSelect.add(new Option(vendor, vendor)));
        this.buildSeriesOptions();
        this.setupSurprise();
        controls.forEach(control => { control.disabled = false; });
        this.restore();
        this.filter(false);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.feedback.hidden = false;
        this.feedback.textContent = this.dataset.error;
        pagination.hidden = false;
      }
    }

    setupSurprise() {
      const panel = this.querySelector('[data-surprise]');
      if (!panel) return;
      const firstVolumes = this.cards.filter(card => /(?:^|[\s-])(?:tomo\s*)?0?1$/i.test(card.dataset.title.trim()) && card.dataset.available === 'true');
      this.surprisePool = firstVolumes;
      if (!this.surprisePool.length) return;
      panel.hidden = false;
      this.querySelector('[data-surprise-button]').addEventListener('click', () => {
        const choices = this.surprisePool.filter(card => card.dataset.id !== this.lastSurprise);
        const pool = choices.length ? choices : this.surprisePool;
        const card = pool[Math.floor(Math.random() * pool.length)];
        this.lastSurprise = card.dataset.id;
        const original = card.querySelector('.nkm-card-link');
        const link = original.cloneNode(true);
        link.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        link.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.sizes = '100px'; });
        const action = card.querySelector('.nkqa')?.cloneNode(true);
        if(action) action.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
        this.querySelector('[data-surprise-card]').replaceChildren(...(action?[link,action]:[link]));
        this.querySelector('[data-surprise-link]').href = original.href;
        this.querySelector('[data-surprise-result]').hidden = false;
        const button = this.querySelector('[data-surprise-button]');
        button.textContent = button.dataset.again;
        button.hidden = this.surprisePool.length < 2;
        this.querySelector('[data-surprise-status]').textContent = card.dataset.title + '. ' + card.querySelector('.nkm-card-bottom').textContent.trim();
      }, {signal: this.controller.signal});
    }
    restore() {
      const params = new URLSearchParams(location.search);
      this.game = ['pokemon','magic'].includes(params.get('game')) ? params.get('game') : '';
      [this.queryKey,'vendor','min_price','max_price'].forEach(key => { this.form.elements[key].value = params.get(key) || ''; });
      this.form.elements.available.checked = params.get('available') === '1';
      this.form.querySelectorAll('[name="series"]').forEach(input => { input.checked = params.getAll('series').includes(input.value); });
      this.sort.value = params.get(this.sortKey) || 'title';
      if (!this.sort.value) this.sort.value = 'title';
    }
    filter(updateUrl = true) {
      if (this.sort.disabled) return;
      const values = new FormData(this.form);
      const query = this.normalize(values.get(this.queryKey) || '');
      const terms = query.split(/\s+/).filter(Boolean);
      const series = values.getAll('series');
      const vendor = values.get('vendor');
      const min = values.get('min_price') === '' ? 0 : Number(values.get('min_price')) * 100;
      const max = values.get('max_price') === '' ? Infinity : Number(values.get('max_price')) * 100;
      const onlyAvailable = values.has('available');
      let count = 0;
      this.cards.forEach(card => {
        const data = card.dataset;
        const productSeries = this.cardSeries.get(card) || [];
        const text = this.normalize([data.title, ...productSeries, data.vendor, data.tags].join(' '));
        const isIsbn = /^[\d\s-]{6,}$/.test(query);
        const queryMatches = isIsbn ? data.isbn.replace(/\D/g, '').includes(query.replace(/\D/g, '')) : terms.every(term => text.includes(term));
        const matches = (!this.game || data.game === this.game) && queryMatches && (!series.length || productSeries.some(title => series.includes(title))) && (!vendor || data.vendor === vendor) && Number(data.price) >= min && Number(data.price) <= max && (!onlyAvailable || (data.available === 'true' && data.backorder !== 'true'));
        card.hidden = !matches;
        if (matches) count++;
      });
      this.querySelectorAll('[data-game-choice]').forEach(control => { const selected = control.dataset.gameChoice === this.game; control.setAttribute('aria-pressed',String(selected)); control.classList.toggle('is-selected',selected); });
      const compareTitle = (a,b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang, {numeric:true,sensitivity:'base'});
      const sort = this.sort.value;
      this.cards.sort((a,b) => sort === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) || compareTitle(a,b) : sort === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) || compareTitle(a,b) : sort === 'newest' ? Number(b.dataset.created) - Number(a.dataset.created) || compareTitle(a,b) : compareTitle(a,b));
      const fragment = document.createDocumentFragment();
      this.cards.forEach(card => fragment.append(card));
      this.grid.append(fragment);
      this.querySelector('[data-result-count]').textContent = `${count} ${count === 1 ? this.dataset.countOne : this.dataset.countLabel}`;
      this.querySelector('[data-empty]').hidden = count > 0;
      const filtersCount = Number(Boolean(query)) + series.length + Number(Boolean(vendor)) + Number(values.get('min_price') !== '') + Number(values.get('max_price') !== '') + Number(onlyAvailable);
      const badge = this.querySelector('[data-filter-count]');
      badge.hidden = filtersCount === 0;
      badge.textContent = filtersCount;
      this.form.querySelectorAll('[data-filter-group]').forEach(group => {
        const active = [...group.querySelectorAll('input, select')].filter(input => input.type === 'checkbox' ? input.checked : input.value.trim() !== '').length;
        const indicator = group.querySelector('[data-group-count]');
        indicator.hidden = active === 0;
        indicator.textContent = active;
      });
      if (updateUrl) {
        const url = new URL(location.href);
        [this.queryKey,'series','vendor','min_price','max_price','available',this.sortKey,'page'].forEach(key => url.searchParams.delete(key));
        for (const [key,value] of values.entries()) if (String(value).trim()) url.searchParams.append(key, key === 'available' ? '1' : value);
        if (sort !== 'title') url.searchParams.set(this.sortKey, sort);
        if (this.game) url.searchParams.set('game',this.game); else url.searchParams.delete('game');
        history.replaceState(null, '', url);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
